export default __webpack_public_path__ + "static/media/Hospitalization.a7942aeb.svg";